var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 35,
    viewBox: "0 0 49 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5229",
    "data-name": "Group 5229",
    transform: "translate(-13865 -796.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    d: "M3,0H5A0,0,0,0,1,5,0V23a0,0,0,0,1,0,0H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(13869 802.57)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 8,
    height: 33,
    rx: 3,
    transform: "translate(13874 797.57)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    d: "M0,0H2A3,3,0,0,1,5,3V20a3,3,0,0,1-3,3H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(13905 802.57)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 8,
    height: 33,
    rx: 3,
    transform: "translate(13897 797.57)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M71.032,449.306H68.758a.758.758,0,0,1-.758-.758v-3.79a.758.758,0,0,1,.758-.758",
    transform: "translate(13798 367.619)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M128.274,444a.758.758,0,0,1,.758.758v3.79a.758.758,0,0,1-.758.758H126",
    transform: "translate(13783.968 367.619)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    x1: 15,
    transform: "translate(13882 816.57)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x2: 11,
    transform: "translate(13886 811.57)",
    fill: "none",
    stroke: "#1baec1",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.10c7f93f4bdce16ffafc17e3abdf16bb.svg";
export { ForwardRef as ReactComponent };